import React from "react";
import { Alert, AlertIcon, Box, Skeleton, Stack, Text } from "@chakra-ui/react";

export const PageSkeleton = ({ rows = 4 }) => (
  <Stack spacing={3}>
    <Skeleton height="40px" />
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton key={index} height="36px" />
    ))}
  </Stack>
);

export const InlineError = ({ message = "Something went wrong." }) => (
  <Alert status="error" borderRadius="md">
    <AlertIcon />
    {message}
  </Alert>
);

export const CompactEmptyState = ({ title, message }) => (
  <Box py={8} textAlign="center">
    <Text fontWeight="semibold">{title}</Text>
    {message ? (
      <Text mt={1} color="gray.500" fontSize="sm">
        {message}
      </Text>
    ) : null}
  </Box>
);

export default PageSkeleton;
